var map = {
	"./Zwiebel-g.png": 25,
	"./Zwiebel-k.png": 26,
	"./apfel-g.png": 27,
	"./apfel-k.png": 28,
	"./aprikose-g.png": 29,
	"./aprikose-k.png": 30,
	"./artischocke-g.png": 31,
	"./artischocke-k.png": 32,
	"./aubergine-g.png": 33,
	"./aubergine-k.png": 34,
	"./birne-g.png": 35,
	"./birne-k.png": 36,
	"./blaubeeren-g.png": 37,
	"./blaubeeren-k.png": 38,
	"./blumenkohl-g.png": 39,
	"./blumenkohl-k.png": 40,
	"./broccoli-g.png": 41,
	"./broccoli-k.png": 42,
	"./brombeere-g.png": 43,
	"./brombeere-k.png": 44,
	"./erbsen-g.png": 45,
	"./erbsen-k.png": 46,
	"./erdbeere-g.png": 47,
	"./erdbeere-k.png": 48,
	"./federkohl-g.png": 49,
	"./federkohl-k.png": 50,
	"./fenchel-g.png": 51,
	"./fenchel-k.png": 52,
	"./gruenebohnen-g.png": 53,
	"./gruenebohnen-k.png": 54,
	"./gurke-g.png": 55,
	"./gurke-k.png": 56,
	"./himbeere-g.png": 57,
	"./himbeere-k.png": 58,
	"./johannisbeere-g.png": 59,
	"./johannisbeere-k.png": 60,
	"./karotten-g.png": 61,
	"./karotten-k.png": 62,
	"./kartoffel-g.png": 63,
	"./kartoffel-k.png": 64,
	"./kefen-g.png": 65,
	"./kefen-k.png": 66,
	"./kirsche-g.png": 67,
	"./kirsche-k.png": 68,
	"./kiwi-g.png": 69,
	"./kiwi-k.png": 70,
	"./knollensellerie-g.png": 71,
	"./knollensellerie-k.png": 72,
	"./kohlrabi-g.png": 73,
	"./kohlrabi-k.png": 74,
	"./kopfsalat-g.png": 75,
	"./kopfsalat-k.png": 76,
	"./krautstiel-g.png": 77,
	"./krautstiel-k.png": 78,
	"./kuerbis-g.png": 79,
	"./kuerbis-k.png": 80,
	"./lauch-g.png": 81,
	"./lauch-k.png": 82,
	"./mais-g.png": 83,
	"./mais-k.png": 84,
	"./meerrettich-g.png": 85,
	"./meerrettich-k.png": 86,
	"./nuesslisalat-g.png": 87,
	"./nuesslisalat-k.png": 88,
	"./pastinake-g.png": 89,
	"./pastinake-k.png": 90,
	"./patisson-g.png": 91,
	"./patisson-k.png": 92,
	"./peperoni-g.png": 93,
	"./peperoni-k.png": 94,
	"./pflaume-g.png": 95,
	"./pflaume-k.png": 96,
	"./placeholder-g.png": 97,
	"./placeholder-k.png": 98,
	"./quitte-g.png": 99,
	"./quitte-k.png": 100,
	"./radieschen-g.png": 101,
	"./radieschen-k.png": 102,
	"./randen-g.png": 103,
	"./randen-k.png": 104,
	"./rhabarber-g.png": 105,
	"./rhabarber-k.png": 106,
	"./rosenkohl-g.png": 107,
	"./rosenkohl-k.png": 108,
	"./rotkohl-g.png": 109,
	"./rotkohl-k.png": 110,
	"./rucola-g.png": 111,
	"./rucola-k.png": 112,
	"./schwarzwurzel-g.png": 113,
	"./schwarzwurzel-k.png": 114,
	"./spargel-gruen-g.png": 115,
	"./spargel-gruen-k.png": 116,
	"./spinat-g.png": 117,
	"./spinat-k.png": 118,
	"./stachelbeere-g.png": 119,
	"./stachelbeere-k.png": 120,
	"./stangensellerie-g.png": 121,
	"./stangensellerie-k 2.png": 122,
	"./stangensellerie-k.png": 123,
	"./suesskartoffel-g.png": 124,
	"./suesskartoffel-k.png": 125,
	"./titelbild.png": 126,
	"./tomate-g.png": 127,
	"./tomate-k.png": 128,
	"./topinambur-g.png": 129,
	"./topinambur-k.png": 130,
	"./trauben-g.png": 131,
	"./trauben-k.png": 132,
	"./weisskohl-g.png": 133,
	"./weisskohl-k.png": 134,
	"./wirz-g.png": 135,
	"./wirz-k.png": 136,
	"./zucchetti-g.png": 137,
	"./zucchetti-k.png": 138
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6;